import { FormControlLabel, Grid, FormGroup, Checkbox, Box } from "@mui/material";

const PatientType = ({
  fields,
  setFields,
  PATIENT_OF,
  MicrotiaImg,
  ArtesiaImg,
  AnotiaImg,
}) => {
  const togglePatientType = (type) => {
    setFields((prevFields) => {
      const updatedPatientOf = prevFields?.patient_of?.includes(type)
        ? prevFields?.patient_of?.filter((t) => t !== type)
        : [...prevFields?.patient_of, type];

      return {
        ...prevFields,
        err: "",
        patient_of: updatedPatientOf,
      };
    });
  };

  return (
    <Grid container spacing={4} sx={{ ml: "auto", mr: "auto" }}>
      <Grid item xs={12} md={12} sx={{ ml: 1 }}>
        <FormGroup>
          <Grid
            container
            spacing={2}
            justifyContent="left"
            sx={{
              pt: 1,
              mt: 0.3,
              border: "2px solid #A91674",
              borderRadius: "8px",
              width: "95%",
            }}
          >
            <Grid item xs={12} sm={5.5}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "left",
                  pl: 1,
                }}
              >
                {/* Artesia */}
                <img
                  src={ArtesiaImg}
                  alt="Atresia"
                  onClick={() => togglePatientType(PATIENT_OF?.ARTESIA)}
                  style={{ width: "80%", height: "400px", cursor: "pointer" }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={fields.patient_of.includes(PATIENT_OF?.ARTESIA)}
                      onChange={() => togglePatientType(PATIENT_OF?.ARTESIA)}
                      color="primary"
                    />
                  }
                  label="Atresia"
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  mt: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {/* Microtia */}
                <img
                  src={MicrotiaImg}
                  alt="Microtia"
                  onClick={() => togglePatientType(PATIENT_OF?.MICROTIA)}
                  style={{ width: "80%", height: "170px", cursor: "pointer" }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={fields?.patient_of?.includes(
                        PATIENT_OF?.MICROTIA
                      )}
                      onChange={() => togglePatientType(PATIENT_OF?.MICROTIA)}
                      color="primary"
                    />
                  }
                  label="Microtia"
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {/* Anotia */}
                <img
                  src={AnotiaImg}
                  alt="Anotia"
                  onClick={() => togglePatientType(PATIENT_OF?.ANOTIA)}
                  style={{ width: "50%", height: "180px", cursor: "pointer" }}
                />
                <FormControlLabel
                  sx={{ mt: 1 }}
                  control={
                    <Checkbox
                      checked={fields?.patient_of?.includes(PATIENT_OF?.ANOTIA)}
                      onChange={() => togglePatientType(PATIENT_OF?.ANOTIA)}
                      color="primary"
                    />
                  }
                  label="Anotia"
                />
              </Box>
            </Grid>
          </Grid>
        </FormGroup>
      </Grid>
    </Grid>
  );
};

export default PatientType;
